import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// SERVICES
import { EnvironmentUtilService } from '../util/environment-util.service';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ScannerServiceApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getScannerData(scannedValue :string) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/scanner?scanned_value=${scannedValue}`,
    );
  }
}
